<div class="ec-measure-aggregations-container">
    <div *ngIf="isDefined(ecInfo?.mode)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
         class="txt-p-14-4" [ngSwitch]="ecInfo.mode">
        <ng-container *ngSwitchCase="ECMode.BASE">
            <app-icon [name]="ecModeIcon"></app-icon>
            <span>{{'Statistical data'|i18n}}</span>
            <app-icon name="fas-info-circle" class="txt-h-14-4"
                      [title]="'Energy data are estimated on GSE-defined statistical profiles and previous year\'s readings, in similar seasonality, and based on rate ranges'|i18n">
            </app-icon>
        </ng-container>
        <ng-container *ngSwitchCase="ECMode.ADVANCED">
            <app-icon [name]="ecModeIcon"></app-icon>
            <span>{{'Monitored data'|i18n}}</span>
            <app-icon name="fas-info-circle" class="txt-h-14-4"
                      [title]="'Based on energy data collected using smart meters'|i18n">
            </app-icon>
        </ng-container>
        <ng-container *ngSwitchCase="ECMode.HYBRID">
            <app-icon [name]="ecModeIcon"></app-icon>
            <span>{{'Hybrid data'|i18n}}</span>
            <app-icon name="fas-info-circle" class="txt-h-14-4"
                      [title]="'The aggregate data of this section are composed of monitored data and statistical data'|i18n">
            </app-icon>
        </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" class="mt-24">
        <mat-button-toggle-group appearance="legacy" class="time-range-selector"
                                 [value]="timeRange" (valueChange)="onSelectTimeRange($event)">
            <mat-button-toggle class="mr-16" [disableRipple]="true" [value]="TimeRange.LAST_HOUR">
                {{'Last hour'|i18n}}
            </mat-button-toggle>
            <mat-button-toggle class="mr-16" [disableRipple]="true" [value]="TimeRange.LAST_24_HOURS">
                {{'Last 24 hours'|i18n}}
            </mat-button-toggle>
            <mat-button-toggle class="mr-16" [disableRipple]="true" [value]="TimeRange.LAST_7_DAYS">
                {{'Last 7 days'|i18n}}
            </mat-button-toggle>
            <mat-button-toggle class="mr-16" [disableRipple]="true" [value]="TimeRange.LAST_30_DAYS">
                {{'Last 30 days'|i18n}}
            </mat-button-toggle>
            <mat-button-toggle class="" [disableRipple]="true" [value]="TimeRange.LAST_60_DAYS">
                {{'Last 60 days'|i18n}}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div fxLayout="row" class="mt-24 txt-s-14-4">
        {{aggregationReferenceTime|i18nTimestamp}}
    </div>
    <div fxLayout="row wrap" fxLayoutGap="15px" class="mt-24 aggregations-row">
        <div *ngFor="let aggregation of aggregatedData; trackBy: trackByIndex"
             fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="aggregation">
            <div *ngIf="ecModeIcon as icon" class="aggregation-icon">
                <app-icon [name]="icon"></app-icon>
            </div>
            <div *ngIf="aggregation.aggregatedValue|async as value; else loadingValue" class="txt-h-14-7">
                <ng-container *ngIf="isDefined(value.value)">
                    <ng-container *appVar="aggregation.uom|async as uom">
                        {{value.value|niceValue:uom}}
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!isDefined(value.value)">
                    -
                </ng-container>
            </div>
            <ng-template #loadingValue>
                <mat-spinner diameter="20"></mat-spinner>
            </ng-template>
            <div class="txt-p-14-4">{{aggregation.name}}</div>
        </div>
    </div>
</div>
